import { useEffect, useState } from "react";
import { BedDouble, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { StayDocumentsList } from "./StayDocumentsList";

const fmtDay = (d) => (d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");

/** Guest Profile → Documents: every stay of the guest with its printed documents (View / Print / Download). */
export function GuestStayDocuments({ guestId, stays: given }) {
  const [stays, setStays] = useState(given ?? null);
  useEffect(() => {
    if (given) { setStays(given); return; }
    api.get(`/pms/guests/${guestId}/stays`).then((r) => setStays(r.data.items || [])).catch(() => setStays([]));
  }, [guestId, given]);

  if (stays === null) return <div className="text-[12px] text-hocp-textMuted flex items-center gap-2"><Loader2 size={13} className="animate-spin" />Loading stays…</div>;
  return (
    <div className="space-y-3" data-testid="guest-stay-documents">
      {stays.length === 0 && <div className="text-[12px] text-hocp-textMuted">No stays yet — documents appear here after check-in.</div>}
      {stays.map((s) => (
        <div key={s.id} className="rounded-lg border border-[#D5E6E8] bg-white p-3" data-testid={`guest-stay-docs-${s.code}`}>
          <div className="flex flex-wrap items-center gap-2 mb-2 text-[12.5px]">
            <BedDouble size={14} className="text-[#014751]" />
            <span className="font-semibold text-[#1A2425] mono">{s.code}</span>
            <span className="text-hocp-textMuted">{fmtDay(s.actual_arrival || s.expected_arrival)} → {fmtDay(s.actual_departure || s.expected_departure)}</span>
            <span className="rounded-full bg-[#E6FEFF] border border-[#37F4B5] px-2 py-0.5 text-[11px] text-[#014751] font-semibold">{(s.status || "").replace(/_/g, " ")}</span>
          </div>
          <StayDocumentsList stayId={s.id} />
        </div>
      ))}
    </div>
  );
}
